import { render, staticRenderFns } from "./BookingHistories.vue?vue&type=template&id=a601d708&"
import script from "./BookingHistories.vue?vue&type=script&lang=js&"
export * from "./BookingHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports